import { useEffect, useState } from 'react';

export const useVoteColors = () => {
    const [voteColors, setVoteColors] = useState({});

    useEffect(() => {
        const style = getComputedStyle(document.body);
        const colors = [
            style.getPropertyValue('--clr-1'),
            style.getPropertyValue('--clr-2'),
            style.getPropertyValue('--clr-3'),
            style.getPropertyValue('--clr-4'),
            style.getPropertyValue('--clr-5'),
            style.getPropertyValue('--clr-6'),
            style.getPropertyValue('--clr-7')
        ];
        setVoteColors({
            'YES': colors[0],
            'NO': colors[1],
            'ABSTAIN': colors[2],
            'NOT_VOTED': colors[3],
            'ABSENT': colors[4],
            'SECRET': colors[5],
            'EXCUSED': colors[6]
        });
    }, []);

    return voteColors;
};

export const useAttendanceColors = () => {
    const [attendanceColors, setAttendanceColors] = useState({});

    useEffect(() => {
        const style = getComputedStyle(document.body);
        const colors = [
            style.getPropertyValue('--clr-1'),
            style.getPropertyValue('--clr-2'),
            style.getPropertyValue('--clr-3'),
            style.getPropertyValue('--clr-4'),
            style.getPropertyValue('--clr-5'),
            style.getPropertyValue('--clr-6'),
            style.getPropertyValue('--clr-7')
        ];
        setAttendanceColors({
            'PRESENT': colors[0],
            'PART_PRESENT': colors[2],
            'ABSENT': colors[1]
        });
    }, []);

    return attendanceColors;
};
